<div
    class="toggle-container"
    [class.active]="value"
    [class.disabled]="disabled"
    [attr.data-uiid]="dataUiid"
    (click)="onClick()"
>
    <div class="toggle-button"></div>
    <div class="toggle-text">
        <div class="toggle-text-true">
            {{ labelOn }}
        </div>
        <div class="toggle-text-false">
            {{ labelOff }}
        </div>
    </div>
</div>
